<template>
  <div
    class="loader-spinner"
    :style="spinnerSize"
  >
    <svg
      class="loader-spinner__wrapper"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="loader-spinner__circle"
        fill="none"
        stroke-width="2"
        stroke-linecap="round"
        cx="16"
        cy="16"
        r="13"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CLoaderSpinner',

  props: {
    size: {
      type: [String, Number],
      default: 1
    }
  },

  computed: {
    spinnerSize () {
      return {
        width: this.size * 2 + 'em',
        height: this.size * 2 + 'em'
      }
    }
  }
}
</script>

<style lang="scss">
@use "sass:math";
@import "../css/variables";

// Source: https://codepen.io/mrrocks/pen/EiplA

$animation-duration: 1.6s;
$animation-offset: 70;

.loader-spinner {
  display: inline-block;
  position: relative;
  overflow: hidden;
}

.loader-spinner__wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;

  animation: loader-spinner $animation-duration linear infinite;
}

.loader-spinner__circle {
  stroke: $color-secondary-dark;
  stroke-dasharray: $animation-offset;
  stroke-dashoffset: 0;
  transform-origin: center;

  animation: loader-circle $animation-duration ease-in-out infinite;
}

@keyframes loader-spinner {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes loader-circle {
  0% {
    stroke-dashoffset: $animation-offset;
  }

  50% {
    stroke-dashoffset: math.div($animation-offset, 4);
    transform: rotate(135deg);
  }

  100% {
    stroke-dashoffset: $animation-offset;
    transform: rotate(360deg);
  }
}
</style>
